/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const AutomaticLti1p3AssignmentImportSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('AUTOMATIC_LTI_1P3_ASSIGNMENT_IMPORT')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecBoolean)],
]);
export class AutomaticLti1p3AssignmentImportSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return AutomaticLti1p3AssignmentImportSettingParser.decode(input).map(res => new AutomaticLti1p3AssignmentImportSetting(res));
    }
    static unsafeDecode(input) {
        return AutomaticLti1p3AssignmentImportSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return AutomaticLti1p3AssignmentImportSettingParser.encode(data);
    }
    static schema() {
        return AutomaticLti1p3AssignmentImportSettingParser.schema();
    }
}
